import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

let supabase = null

if (supabaseUrl && supabaseAnonKey) {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
} else {
  console.warn(
    '[Supabase] REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY missing; Supabase auth is disabled for this build.'
  )
}

export { supabase }
